<template>
  <div class="tire-recommend">
    <!-- 基本信息 -->
    <div
      class="basic-info"
      v-if="
        !(
          !notEmpty(tireSpec) &&
          !notEmpty(maintainInfo) &&
          tireInfo.length == 0
        )
      "
    >
      <div class="sub-title">基本信息</div>
      <div
        v-if="tireInfo.length > 0"
        :class="{
          'products-box': true,
        }"
      >
        <div class="product-box" v-for="(item, index) in tireInfo" :key="index">
          <img
            @click="preview(item.imageUrls)"
            :src="item.imageUrls[0]"
            alt=""
          />
          <span>{{ item.brandName + " " + item.nickName }}</span>
        </div>
      </div>
      <div v-else class="empty">
        <div class="empty-box">
          <img
            class="empty-img"
            src="https://select-oil-oss.vchangyi.com/wxapp/no-product-bg.png"
          />
          <span>暂无产品推荐～</span>
        </div>
      </div>
    </div>
    <!-- 轮胎规格 -->
    <div class="spec" v-if="notEmpty(tireSpec)">
      <div class="sub-title">轮胎规格</div>
      <div class="table">
        <div class="tr">
          <div class="td td11">前轮胎规格</div>
          <div class="td td12 content">{{ tireSpec.front_attrs }}</div>
        </div>
        <div class="tr">
          <div class="td td21">后轮胎规格</div>
          <div class="td td22 content">{{ tireSpec.after_attrs }}</div>
        </div>
        <div class="tr">
          <div class="td td31">轮毂规格</div>
          <div class="td td32 content">
            {{ tireSpec.wheel_hub_attrs ? tireSpec.wheel_hub_attrs : "--" }}
          </div>
        </div>
      </div>
    </div>
    <!-- 胎压复位 -->
    <div class="tire-pressure" v-if="notEmpty(maintainInfo)">
      <div class="sub-title">胎压复位</div>
      <div class="item" v-if="maintainInfo.tpms">
        <div class="left">胎压报警灯</div>
        <div class="right">{{ maintainInfo.tpms }}</div>
      </div>
      <div class="item" v-if="maintainInfo.tireSensor">
        <div class="left">胎压传感器</div>
        <div class="right">{{ maintainInfo.tireSensor }}</div>
      </div>
      <div class="item" v-if="maintainInfo.sensorRate">
        <div class="left">胎压传感器频率</div>
        <div class="right">{{ maintainInfo.sensorRate }}</div>
      </div>
      <div v-if="maintainInfo.advice" :class="{ item: true, multiple: true }">
        <div class="left">技师建议</div>
        <div class="right">
          {{ maintainInfo.advice }}
        </div>
      </div>
    </div>
    <div
      class="all-empty"
      v-if="
        !notEmpty(tireSpec) && !notEmpty(maintainInfo) && tireInfo.length == 0
      "
    >
      <div class="empty-box">
        <img
          src="https://select-oil-oss.vchangyi.com/wxapp/no-product-bg.png"
          class="empty-img"
          alt="empty"
        />
        <span>暂无产品推荐～</span>
      </div>
    </div>
    <!-- 备注说明 -->
    <MediaView v-if="mediaList.flat().length > 0" :mediaList="mediaList" />
  </div>
</template>
<script>
import MediaView from "./MediaView.vue";
import { setStatistics } from "@/utils/common";
import api from "@/apis/maintenance-api.js";
import { userQueryCarModelRecord } from "@/utils/data-burial";
import validToken from "@/mixins/valid-token.js";
export default {
  mixins: [validToken],
  components: { MediaView },
  props: {
    query: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tireInfo: {},
      maintainInfo: {},
      mediaList: [[], []],
      tireSpec: {
        front_attrs: "",
        after_attrs: "",
        wheel_hub_attrs: "",
      },
      vehicle_id: "",
    };
  },
  async mounted() {
    console.log("query", this.query);
    this.vehicle_ids = decodeURIComponent(this.query.vehicle_ids).split(","); //获取动态的参数
    this.dynamic_vehicle_ids_query = encodeURIComponent(
      this.vehicle_ids.join(",")
    );
    await this.fetchDetail();
    await this.queryDataRecord();
    // console.log(this.tireInfo, this.maintainInfo, this.tireSpec);
  },
  methods: {
    goHome() {
      this.$router.push({
        path: "/home",
        query: {
          id: this.query.scheme_id,
        },
      });
    },
    async fetchDetail() {
      await this.fetchValidToken();
      if (!this.token) return;
      this.$loading.show("加载中...");
      const scheme_id = this.$route.query.scheme_id || this.$route.query.id;
      const params = {
        parts_type: 3,
        vehicle_ids: this.vehicle_ids,
        token: this.token,
        scheme_id,
      };
      try {
        // 优先取缓存数据
        let cacheDetail = null;
        const tireCacheString = sessionStorage.getItem("tireCache");
        if (
          tireCacheString &&
          JSON.parse(tireCacheString).key === this.dynamic_vehicle_ids_query
        ) {
          cacheDetail = JSON.parse(tireCacheString).value;
        }
        const res = cacheDetail || (await api.getModelDetail(params));
        if (
          res.code !== 0 &&
          (res.code === 40800 ||
            res.code === 40700 ||
            res.code === 40900 ||
            res.code === 40910)
        ) {
          this.$toast.show({
            showTime: 2,
            message: res.message,
            style: "error",
          });
          return;
        }
        sessionStorage.setItem(
          "tireCache",
          JSON.stringify({
            key: encodeURIComponent(this.vehicle_ids.join(",")),
            value: res,
          })
        );
        this.vehicle_id =
          res.data.vehicle_list && res.data.vehicle_list[0]
            ? res.data.vehicle_list[0].id
            : this.query.id
            ? this.query.id
            : "";
        // set 轮胎信息
        if (this.query.key === "default" || !this.query.key) {
          this.tireInfo = res.data.parts_list[0]
            ? res.data.parts_list[0].merge_parts
            : [];
          // 设置前后轮规格
          this.tireSpec.front_attrs =
            res.data.parts_list[0].front_attrs.length > 0
              ? res.data.parts_list[0].front_attrs.reduce((res, cur) => {
                  res = `${res} ${cur[0].attrValue}`;
                  return res;
                }, "")
              : "";
          this.tireSpec.after_attrs =
            res.data.parts_list[0].after_attrs.length > 0
              ? res.data.parts_list[0].after_attrs.reduce((res, cur) => {
                  res = `${res} ${cur[0].attrValue}`;
                  return res;
                }, "")
              : "";
          // 设置轮毂规格
          this.tireSpec.wheel_hub_attrs = `${
            res.data.parts_list[0].front_wheel_hub
              ? res.data.parts_list[0].front_wheel_hub
              : "--"
          }/${
            res.data.parts_list[0].after_wheel_hub
              ? res.data.parts_list[0].after_wheel_hub
              : "--"
          }`;
          if (this.tireSpec.wheel_hub_attrs == "--/--") {
            this.tireSpec.wheel_hub_attrs = "";
            if (this.notEmpty(this.tireSpec)) {
              this.tireSpec.wheel_hub_attrs == "--/--";
            }
          }
        } else {
          let curInfo = res.data.parts_list.find(
            (i) => i.key == this.query.key
          );
          this.tireInfo = curInfo.merge_parts;
          // 设置前后轮规格
          this.tireSpec.front_attrs =
            curInfo.front_attrs.length > 0
              ? curInfo.front_attrs.reduce((res, cur) => {
                  res = `${res} ${cur[0].attrValue}`;
                  return res;
                }, "")
              : "";
          this.tireSpec.after_attrs =
            curInfo.after_attrs.length > 0
              ? curInfo.after_attrs.reduce((res, cur) => {
                  res = `${res} ${cur[0].attrValue}`;
                  return res;
                }, "")
              : "";
          this.tireSpec.wheel_hub_attrs = `${
            curInfo.front_wheel_hub ? curInfo.front_wheel_hub : "--"
          }/${curInfo.after_wheel_hub ? curInfo.after_wheel_hub : "--"}`;
          if (this.tireSpec.wheel_hub_attrs == "--/--") {
            this.tireSpec.wheel_hub_attrs = "";
            if (this.notEmpty(this.tireSpec)) {
              this.tireSpec.wheel_hub_attrs == "--/--";
            }
          }
        }
        // 设置养护信息
        // if (this.$route.query.key == "default" || !this.$route.query.key) {
        // 轮胎不同key只对应同一个养护信息，推荐轮胎与轮胎规格按key筛选
        if (res.data.datum_list.length > 0) {
          let maintainTemp = res.data.datum_list[0].datum_detail.datumAttrs;
          this.maintainInfo = maintainTemp.reduce((res, cur) => {
            res[`${cur.attrKey}`] = cur.attrValue;
            return res;
          }, {});
          this.sortMedia(res.data.datum_list[0].datum_detail.datumImages);
        }
        // } else {
        //   let maintainTemp = res.data.datum_list.find(
        //     (i) => i.key === this.$route.query.key
        //   );
        //   this.maintainInfo = maintainTemp.datum_detail.datumAttrs;
        //   this.maintainInfo = this.maintainInfo.reduce((res, cur) => {
        //     res[`${cur.attrKey}`] = cur.attrValue;
        //     return res;
        //   }, {});
        //   this.sortMedia(maintainTemp.datum_detail.datumImages);
        // }
      } catch (error) {
        console.log(error);
        this.$loading.hide();
      }
      this.$loading.hide();
    },
    sortMedia(mediaArrs) {
      let temp1 = mediaArrs
        .filter((i) => i.resName === "胎压灯复位指导" && i.resType == 0)
        .map((i) => i.resUrl);
      // TODO-视频
      // let temp2 = mediaArrs
      //   .filter((i) => i.resName === "胎压灯复位指导" && i.resType == 1)
      //   .map((i) => i.resUrl);
      // let tempArr = [];
      // temp2.length > 0 && temp2.forEach((i) => tempArr.push(i));
      temp1.length == 0 ? (temp1 = []) : "";
      this.mediaList = [temp1];
    },
    preview(imgsArr, idx = 0) {
      this.$imagePreview({
        images: imgsArr,
        index: idx,
        defaultOpt: {
          fullscreenEl: false,
          arrowEl: true,
          preloaderEl: true,
          bgOpacity: 0.85,
          preload: [1, 1],
          showHideOpacity: true,
          showAnimationDuration: 0,
        },
      });
    },
    // 判断字符串的对象，有一个键不为空，返回true
    notEmpty(obj) {
      return !!Object.keys(obj).find((i) => obj[i] != "");
    },
    // 查询数据记录
    async queryDataRecord() {
      if (!window.localStorage.getItem("OILUSER")) {
        await setStatistics.apply(this, []);
      }
      const uuid = window.localStorage.getItem("OILUSER")
        ? Number(window.localStorage.getItem("OILUSER"))
        : "";
      const { internal_from } = this.query;
      const basic_info = {
        choose_vehicle_id: this.vehicle_ids[0],
        menu_type: 3,
        uuid: uuid,
        scheme_id: this.query.scheme_id,
        search_type:
          internal_from === "photo_vin"
            ? 2
            : internal_from === "text_vin"
            ? 3
            : 1,
      };
      await userQueryCarModelRecord.apply(this, [basic_info]);
    },
  },
};
</script>
<style lang="less" scoped>
.tire-recommend {
  display: flex;
  background-color: #fafafa;
  flex-direction: column;
  .all-empty {
    height: 70vh;
    display: flex;
    justify-content: center;
    align-items: center;
    .empty-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      .empty-img {
        // margin-top: 208/100rem;
        width: 133/100rem;
        height: 133/100rem;
      }
      span {
        margin-top: 26/100rem;
        font-size: 24/100rem;
        color: #666666;
      }
    }
  }
  .model-name {
    color: #404040;
    font-size: 27/100rem;
    margin: 34/100rem auto 34/100rem 17/100rem;
  }
  .basic-info {
    display: flex;
    background-color: #fff;
    padding: 26/100rem;
    padding-bottom: 0;
    flex-direction: column;
    // height: 401/100rem;
    margin-bottom: 26/100rem;
    box-shadow: 0px 10/100rem 27/100rem 0px rgba(207, 207, 207, 0.2);
    border-radius: 20/100rem;
    .sub-title {
      margin-bottom: 34/100rem;
      color: #404040;
      font-size: 27/100rem;
      font-weight: 600;
    }
    .single-box {
      justify-content: center;
    }
    .two-box {
      justify-content: space-between;
      padding: 0 20/100rem;
    }
    .three-box {
      overflow-x: scroll;
      overflow: -moz-scrollbars-none;
      -ms-overflow-style: none;
      .product-box {
        width: 184/100rem;
      }
    }
    .products-box {
      display: flex;
      flex-direction: column;
      height: auto;
      .product-box {
        overflow: auto;
        flex-shrink: 0;
        display: flex;
        color: #404040;
        font-size: 24/100rem;
        text-align: center;
        img {
          width: 126/100rem;
          height: 126/100rem;
          margin-bottom: 26/100rem;
          border-radius: 9/100rem;
          border: 1/100rem solid #eeeeee;
          // box-shadow: 0px 3/100rem 20/100rem 0px rgba(0, 0, 0, 0.05);
          margin-right: 15/100rem;
        }
        span {
          box-sizing: content-box;
          line-height: 34/100rem;
          font-size: 20/100rem;
        }
      }
    }
    .products-box::-webkit-scrollbar {
      width: 0 !important;
    }
    .empty {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      .empty-box {
        display: flex;
        flex-direction: column;
        img {
          width: 133/100rem;
          height: 133/100rem;
        }
        span {
          margin-top: 12/100rem;
          color: #7f7f7f;
          font-size: 24/100rem;
          margin-bottom: 20/100rem;
        }
      }
    }
  }
  // 轮胎规格
  .spec {
    width: 100%;
    background-color: #fff;
    height: 372/100rem;
    padding: 26/100rem;
    box-shadow: 0px 10/100rem 27/100rem 0px rgba(207, 207, 207, 0.2);
    border-radius: 20/100rem;
    display: flex;
    flex-direction: column;
    margin-bottom: 26/100rem;
    .sub-title {
      margin-bottom: 17/100rem;
      color: #404040;
      font-size: 27/100rem;
      font-weight: 600;
    }
    .table {
      border: 2/100rem solid #f0f0f0;
      border-radius: 17/100rem;
      border-collapse: collapse;
      font-size: 24/100rem;
      color: #404040;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      .tr {
        display: flex;
      }
      .td,
      .th {
        border-collapse: collapse;
        border-bottom: 2/100rem solid #f0f0f0;
        border-right: 2/100rem solid #f0f0f0;
        width: 50%;
        text-align: center;
        height: 87/100rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .td12,
      .td22,
      .td32 {
        border-right: none;
      }
      .td31,
      .td32 {
        border-bottom: none;
      }
      .content {
        color: #999999;
      }
    }
  }
  // 胎压复位
  .tire-pressure {
    height: auto;
    display: flex;
    background-color: #fff;
    flex-direction: column;
    padding: 26/100rem;
    margin-bottom: 26/100rem;
    box-shadow: 0px 10/100rem 27/100rem 0px rgba(207, 207, 207, 0.2);
    border-radius: 20/100rem;
    .sub-title {
      color: #404040;
      font-size: 27/100rem;
      font-weight: 600;
      margin-bottom: 17/100rem;
    }
    .item {
      // border-bottom: 2/100rem #f0f0f0 solid;
      min-height: 85/100rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 24/100rem;
      &:last-child {
        border-bottom: none;
      }
      .left {
        color: #999999;
        white-space: nowrap;
        margin-right: 30/100rem;
      }
      .right {
        color: #666666;
      }
    }
    .multiple {
      align-items: start;
      padding: 30/100rem 0;
      line-height: 35/100rem;
    }
  }
}
</style>
